import React from 'react';
import classNames from 'classnames/bind';
import Box from '../../components/Hover/Box';
import styles from './Sustentability.module.scss';


let cx = classNames.bind(styles);

const Sustentability = () => {
	return (
		<section
			id='sustentabilidad'
			className={cx({ sustentability: true, 'hidden lg:block mt-10 py-10': true })}
		>
			<div className='container mx-auto  flex flex-col justify-start items-center'>
				<h1 className='text-tcn-dark-blue font-Avenir-Black text-5xl py-4'>
					<strong className='font-Avenir-Black'>SUSTENTABILIDAD</strong>
				</h1>

			</div>
			<div className='container mx-auto w-full flex flex-wrap flex-row'>
				<div className='flex w-1/2'>
					<Box
						background_image='Fondo_Comunidad.png'
						image_name='Comunidad.png'
						p1='Busca el desarrollo y bienestar de las personas y de nuestros grupos de interés en las comunidades donde operamos. Ideal aporta su granito de harina en beneficio de quienes más lo necesitan.'
						p2='Buen Vecino: IDEAL en el 2019 impulso la reconstrucción y remodelación de las instalaciones de un jardín infantil y sala cuna del programa integra, salones de la casa de la Juventud, ubicados ambos proyectos en la comuna de Lo Espejo.'
					/>
				</div>
				<div className='flex w-1/2'>
					<Box
						background_image='PLaneta_fondo.png'
						image_name='Planeta.png'
						p1='Implementa las acciones que reducen la huella ambiental de nuestra cadena de valor, para así cuidar a nuestro planeta y el uso de los recursos naturales.'
						p2='Paneles Solares: En nuestra planta de Quilicura contamos con el techo fotovoltaico más grande del país y de Sudamérica. Anualmente se mitigará 1.310 toneladas de CO2 en la atmósfera, lo que equivale a plantar una superficie de más de 88.870 árboles.'
					/>
				</div>
				<div className='flex w-1/2'>
					<Box
						background_image='Fondo_colaboradores.png'
						image_name='Colaboradores.png'
						p1='Trabaja por crear un mejor lugar para trabajar con condiciones favorables que sigan la regla de oro: Respeto, Justicia, Confianza y Afecto.'
						p2='La dimensión mejor evaluada en el año 2019 fue ambiente laboral con 77,8 pts., se confirmó en la encuesta laboral de Grupo Bimbo OHI.'
					/>
				</div>
				<div className='flex w-1/2'>
					<Box
						background_image='20200521_IDEAL_tcn-58.png'
						image_name='Bienestar.png'
						p1='Se enfoca a sensibilizar, posicionar, gestionar y crear líneas de acción a favor de una mejora en nuestros productos y en promocionar estilos de vida saludables que contribuyan con una mejor calidad de vida de nuestros consumidores.'
						p2='Global Energy Race este año fue virtual y tuvimos inscritos de 127 países, gracias a cada uno de quienes participaron, 6 millones de rebanadas de pan fueron donadas a bancos de alimentos.'
					/>
				</div>
			</div>

		</section>
	);
};

export default Sustentability;
